import React from 'react';

const CheckBox = props => {
  const {
    className,
    id,
    value,
    onChange,
    labelLocale,
    disabled
  } = props;
  const dataPath = props["data-path"];
  const dataAssignId = props["data-assignid"];
  const dataAssignEntity = props["data-assignentity"];
  const dataMetricEditor = props["data-metriceditor"];
  const dataTemplateEditor = props["data-templateeditor"];
  
  return (
    <label className={"custom-input matter-checkbox" + (className ? " " + className : "") }>
      <input 
        id={id}
        data-path={dataPath}
        data-assignid={dataAssignId}
        data-assignentity={dataAssignEntity}
        data-metriceditor={dataMetricEditor}
        data-templateeditor={dataTemplateEditor}
        type="checkbox"              
        checked={value}
        onChange={onChange}
        disabled={disabled}
      />
      <span>{labelLocale}</span>
    </label>
  );
};

export default CheckBox;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/checkBox.jsx